import styled from "styled-components/macro";

export const AddressMain = styled.div`
  flex: 1;
`;

export const Line1 = styled.div`
  box-sizing: border-box;
  border-bottom: 1px solid #e5e5e5;
  padding: 6px;
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 4px;
`;

export const Line2 = styled.div`
  box-sizing: border-box;
  display: flex;

  @media (max-width: 430px) {
    flex-wrap: wrap;
  }
`;

export const Label = styled.label`
  display: block;
  color: #828c8d;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  margin-left: 2px;
  margin-bottom: 0px;
`;

export const Input = styled.input`
  border: none;
  box-sizing: border-box;
  display: block;
  padding: 4px 2px;
  max-width: 100%;
  width: 100%;
  color: #222;
  font-size: 18px;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  border-radius: 4px;

  &:focus {
    outline: none;
    box-shadow: ${(props) =>
      !props.hideInternalFocusStyles && "0 0 0 1px rgba(52, 144, 220, 0.3)"};
  }
`;
